module.exports = __webpack_public_path__ + "img/T1B_xh_6.e8921baa.png";